import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

import type { CampaignStatus } from 'infrastructure/enums';
import type {
  IGetSmsCampaignsResponse,
  IPartialPaginationMeta,
} from 'infrastructure/interfaces';

export const CAMPAIGNS_PER_PAGE = 10;

export type TSmsCampaignProps = {
  status?: CampaignStatus;
} & IPartialPaginationMeta;

const queryFn = async (filter: TSmsCampaignProps) => {
  const url = 'core-2/patients/sms-campaign';
  const { data, error } = await dataService.getList<IGetSmsCampaignsResponse>(
    apiUrlGenerator(url, filter),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const getCampaignsQueryKey = (filter: TSmsCampaignProps) => [
  'getSmsCampaigns',
  filter,
];

export const useGetCampaigns = (filter: TSmsCampaignProps) => {
  const filterWithItems = {
    ...filter,
    items: CAMPAIGNS_PER_PAGE,
  };

  const queryKey = getCampaignsQueryKey(filterWithItems);

  const { data, isLoading, isFetching, error } = useQuery<
    IGetSmsCampaignsResponse | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: async () => queryFn(filterWithItems),
    keepPreviousData: true,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { data, isLoading, isFetching };
};
